"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mappers_1 = require("../mappers");
const TemplateMapper_1 = require("../mappers/TemplateMapper");
const message_1 = require("../message");
const models_1 = require("../models");
const roleAccess_1 = require("../roleAccess/roleAccess");
const Observable_1 = require("../socket/Observable");
const utils_1 = require("../utils");
const SyncException_1 = require("../utils/SyncException");
const DomainEvents_1 = require("../utils/DomainEvents");
const AssignDeviceException_1 = require("./exceptions/AssignDeviceException");
const IChat_1 = require("./IChat");
const BaseChat_1 = require("./BaseChat");
const uuid_1 = require("uuid");
const MarkAsReadTracker_1 = __importDefault(require("./MarkAsReadTracker"));
class Chat extends BaseChat_1.BaseChat {
    get templates() {
        return this._templates;
    }
    constructor(chatInfo, organizationUser, config, httpAdapter, socketAdapter, userDirectory, chatInfoFetcher) {
        super(chatInfo, httpAdapter, socketAdapter, userDirectory, organizationUser, chatInfoFetcher);
        this.everFetchedMessages = false;
        this._templates = [];
        this.pendingSends = new Map();
        this.pendingEdits = new Map();
        this.retriesInFlight = new Set();
        this.onSendMessageResponse = (responseData, payload) => {
            var _a;
            const { messageId } = payload.data;
            const message = this.findMessageById(messageId);
            if ((_a = responseData.data) === null || _a === void 0 ? void 0 : _a.duplicate) {
                this.reconcileDuplicateSend(messageId, responseData.data.existingMessage);
                return;
            }
            if (responseData.statusCode && responseData.statusCode !== 200) {
                this.resolvePendingSend(messageId);
                message && this.setMessageStatus(messageId, models_1.MESSAGE_STATUS.FAILED);
            }
        };
        this.onEditMessageResponse = (responseData, payload) => {
            const succeeded = !responseData.statusCode || responseData.statusCode === 200;
            if (succeeded) {
                this.resolvePendingEdit(payload._id);
                this.setMessageEditStatus(payload._id, undefined);
                return;
            }
            this.setMessageEditStatus(payload._id, models_1.EDIT_MESSAGE_STATUS.FAILED);
        };
        this.config = config;
        this.chatsChatInfo = chatInfoFetcher;
        this._groupAssets = this.resetGroupAsset();
        this._scheduledVisits = [];
        this._assignedPatients = [];
        this._userMedia = [];
        this.sendMessageHandler = new message_1.SendMessageHandler(this.socketAdapter, this.config, this._chatInfo, this.getChatType(), this.getChatId(), this.mediaBlobMap, this.userDirectory);
    }
    getContextMenu() {
        const messageActions = [
            message_1.MESSAGE_CONTEXT_MENU.INFO,
            message_1.MESSAGE_CONTEXT_MENU.ASK_ACKNOWLEDGEMENT,
            message_1.MESSAGE_CONTEXT_MENU.STAR_MESSAGE,
            message_1.MESSAGE_CONTEXT_MENU.UNSTAR_MESSAGE,
            message_1.MESSAGE_CONTEXT_MENU.COPY,
            message_1.MESSAGE_CONTEXT_MENU.EDIT,
            message_1.MESSAGE_CONTEXT_MENU.REPLY,
            message_1.MESSAGE_CONTEXT_MENU.RESEND,
            message_1.MESSAGE_CONTEXT_MENU.RESEND_AS_PRIORITY,
            message_1.MESSAGE_CONTEXT_MENU.FORWARD_MESSAGE,
            message_1.MESSAGE_CONTEXT_MENU.DELETE_MESSAGE,
        ];
        this.isPatientGroup() &&
            messageActions.push(message_1.MESSAGE_CONTEXT_MENU.VISIBLE_TO_PATIENT);
        this.isPatientOrInternalGroup() &&
            messageActions.push(message_1.MESSAGE_CONTEXT_MENU.VISIBLE_TO_PHYSICIAN);
        return messageActions;
    }
    markMessageAsRead(message) {
        const lastReadMessage = this.chatsChatInfo.getLastMessageRead(this.chatInfo.id);
        const unreadMessageCount = this.chatsChatInfo.getUnreadMessageCount(this.chatInfo.id);
        const lastMessage = message.getMessage();
        if ((!lastReadMessage || lastReadMessage !== lastMessage.id) &&
            lastMessage.status !== models_1.MESSAGE_STATUS.PENDING) {
            const markAsReadRequest = (0, mappers_1.messageUnmapper)(lastMessage);
            if (!!lastReadMessage &&
                this.getChatType() === "GROUP" &&
                this.chatInfo.groupType === models_1.GROUP_TYPE.PATIENT) {
                console.debug(`Sending MARK_AS_READ for ${this.chatInfo.id}, ${lastMessage.id}`);
                MarkAsReadTracker_1.default.getInstance().expect(this.chatInfo.id, lastMessage.id);
            }
            this.sendMessageHandler.markMessageAsRead(markAsReadRequest);
        }
        else if (unreadMessageCount > 0) {
            console.log(`Possible Error: not marking message ${lastMessage.id} as read, but unread message count ${unreadMessageCount}. Context: lastReadMessage: ${lastReadMessage}, lastMessage status: ${lastMessage.status}`);
        }
    }
    get scheduledVisits() {
        return this._scheduledVisits;
    }
    get groupAssets() {
        return this._groupAssets;
    }
    get template() {
        return this._template;
    }
    unreadMessageCount() {
        return this.chatsChatInfo.getUnreadMessageCount(this._chatInfo.id);
    }
    lastMessageRead() {
        return this.chatsChatInfo.getLastMessageRead(this._chatInfo.id);
    }
    getTemplateByKey(templateKey) {
        return this.organizationUser.getTemplateByKey(templateKey, this.chatInfo, this.templateFilledBy);
    }
    fetchTemplates(filledBy, context) {
        return __awaiter(this, void 0, void 0, function* () {
            if (filledBy)
                this.templateFilledBy = filledBy;
            const templatesResponse = yield this.httpAdapter
                .getChatAdapter()
                .getChatTemplates(this.getChatId(), filledBy, context);
            if (templatesResponse.isAborted)
                return;
            this._templates = yield (0, TemplateMapper_1.templatesMapper)(templatesResponse.data);
            this.changeListeners.forEach(l => l.cb(this));
        });
    }
    fetchTemplate(templateKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const templateResponse = yield this.httpAdapter
                .getChatAdapter()
                .getTemplate(templateKey);
            if (templateResponse === null || templateResponse === void 0 ? void 0 : templateResponse.templateMapper) {
                this._template = templateResponse === null || templateResponse === void 0 ? void 0 : templateResponse.templateMapper(templateResponse, {
                    fillingBy: this.templateFilledBy,
                    chatInfo: this.chatInfo,
                    organizationUser: this.organizationUser,
                });
            }
            else {
                this._template = templateResponse;
            }
            this.changeListeners.forEach(l => l.cb(this));
        });
    }
    setEverFetchedMessages(everFetchedMessages) {
        this.everFetchedMessages = everFetchedMessages;
    }
    hasEverFetchedMessages() {
        return this.everFetchedMessages;
    }
    init() {
        if (this.removeListeners && this.removeListeners.length > 0) {
            throw new Error("Panic: Listeners should have been destoryed during unmount!!!");
        }
        this.removeListeners.push(this.addMessageHandler(() => {
            this.notifyChange();
        }));
        this.removeListeners.push(this.sendMessageListener(() => {
            this.notifyChange();
        }));
        this.removeListeners.push(this.updateMessageListener(() => {
            this.notifyChange();
        }));
        this.removeListeners.push(this.deleteMessageListener(() => {
            this.notifyChange();
        }));
        this.removeListeners.push(this.updateGroupListener(() => {
            this.notifyChange();
        }));
        this.removeListeners.push(this.organizationUser.addSlowMessageSendListener((data) => {
            this.onSendTimedOut(data);
        }));
    }
    onSocketAuthSuccess(lastHeartbeatReceivedAt, abortContext) {
        return __awaiter(this, void 0, void 0, function* () {
            // A non-member chat can be cached only to render the chat-info drawer
            // (e.g. a pending referral opened from Alerts). The message-sync endpoint
            // requires membership and 400s for non-members, so refresh the
            // chat info but skip the message sync.
            if (!this.isMember()) {
                yield this.fetchChatInfo(utils_1.HHNConstants.HEADER_SOURCE_SYNC, abortContext);
                this.notifyChange();
                return;
            }
            yield (0, utils_1.allSettled)([
                this.fetchChatInfo(utils_1.HHNConstants.HEADER_SOURCE_SYNC, abortContext),
                this.syncMessages(lastHeartbeatReceivedAt, abortContext),
            ]);
            this.notifyChange();
        });
    }
    registerChangeListener(cb) {
        const id = (0, uuid_1.v4)();
        this.changeListeners.push({ id, cb });
        return () => {
            this.changeListeners = this.changeListeners.filter(listner => listner.id !== id);
        };
    }
    resetGroupAsset() {
        return {
            data: [],
            limit: utils_1.HHNConstants.PAGINATION_LIMIT,
            page: 0,
            total: 0,
        };
    }
    pushMessage(callback, message) {
        const isSender = message.user ===
            this.organizationUser.getOrganization().userProfile.id;
        const finalMessage = (0, mappers_1.messageMapper)(message, this.userDirectory, this.organizationUser.getOrganization());
        const updatedMessage = finalMessage &&
            this.processMessageData(finalMessage, message.messageId);
        const isMessagePresent = updatedMessage &&
            this._messages.messages.find(message => message.getMessage().messageId ===
                updatedMessage.getMessage().messageId);
        if (isSender && isMessagePresent) {
            // Update existing pending message
            this.resolvePendingSend(message.messageId);
            this.updateMessage(callback, message, true);
            console.log("Message already present", message.messageId, message.status);
            return;
        }
        if (updatedMessage) {
            const updatedMessageData = Object.assign(Object.assign({}, this._messages), {
                messages: [updatedMessage],
                mediaList: updatedMessage.containsMedia() ? [updatedMessage] : [],
            });
            ({ messages: this._messages, mediaList: this.mediaList } =
                this.upsertMessages(this._messages, this.mediaList, updatedMessageData, (existingMessages, newMessaages) => {
                    const { 
                    /* eslint-disable @typescript-eslint/no-unused-vars */
                    messages, mediaList, limit, hasNext, total, page, messageFilters } = newMessaages, rest = __rest(newMessaages, ["messages", "mediaList", "limit", "hasNext", "total", "page", "messageFilters"]);
                    /* eslint-enable @typescript-eslint/no-unused-vars */
                    return Object.assign(Object.assign({}, this.pageAndFilterData(existingMessages)), rest);
                }, "CUSTOM", (existingItems, newItem) => {
                    const index = existingItems.findIndex(item => new Date(item.getMessage().createdAt) <
                        new Date(newItem.getMessage().createdAt));
                    return [
                        ...existingItems.slice(0, index),
                        newItem,
                        ...existingItems.slice(index),
                    ];
                }));
        }
        callback(this._messages, updatedMessage);
    }
    /**
     * The send landed and only the ack was lost. The placeholder still holds the
     * client messageId as its document id, so it has to be replaced by the
     * stored copy — otherwise delete, star and forward target a message the
     * backend does not have.
     */
    reconcileDuplicateSend(messageId, existingMessage) {
        if (!existingMessage) {
            // The flag alone proves the send landed, so resolve on it rather than
            // leaving the bubble stuck.
            this.resolvePendingSend(messageId);
            this.setMessageStatus(messageId, models_1.MESSAGE_STATUS.ACTIVE);
            return;
        }
        // The event the lost echo would have fired: pushMessage already swaps a
        // pending send for the server's copy and clears the outbox record.
        // messageId is stamped on because pushMessage matches the placeholder by
        // it; without it the copy arrives as a second bubble.
        Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.RECEIVE_MESSAGE, this.getChatId()), Object.assign(Object.assign({}, existingMessage), { messageId }));
    }
    /**
     * Swaps the instance as well as the status: the message list rows are
     * memoised on object identity, so a status mutated in place alone never
     * reaches the screen.
     */
    setMessageStatus(messageId, status) {
        const message = this.findMessageById(messageId);
        if (!message) {
            return;
        }
        message.updateMessageStatus(status);
        this._messages = Object.assign(Object.assign({}, this._messages), { messages: this._messages.messages.map(existing => existing.getMessage().messageId === messageId
                ? this.makeDetachedMessage(existing.getMessage())
                : existing) });
        this.notifyChange();
    }
    findMessageById(messageId) {
        return this._messages.messages.find(message => message.getMessage().messageId === messageId);
    }
    trackPendingSend(payload, sentAt) {
        const pendingSend = {
            payload,
            sentAt,
        };
        this.pendingSends.set(payload.messageId, pendingSend);
        this.persistPendingSend(pendingSend);
    }
    findMessageByServerId(serverMessageId) {
        return this._messages.messages.find(message => message.getMessage().id === serverMessageId);
    }
    trackPendingEdit(payload, originalMessage) {
        const pendingEdit = {
            payload,
            originalMessage,
            sentAt: Date.now(),
        };
        this.pendingEdits.set(payload._id, pendingEdit);
        void message_1.EditOutbox.getInstance().save(Object.assign({ chatId: this.getChatId() }, pendingEdit));
    }
    resolvePendingEdit(serverMessageId) {
        this.pendingEdits.delete(serverMessageId);
        void message_1.EditOutbox.getInstance().remove(serverMessageId);
    }
    /**
     * Written before the network round trip, not after, so a reload or tab close
     * between emit and ack still leaves a record to recover from.
     */
    persistPendingSend(pendingSend) {
        void message_1.MessageOutbox.getInstance().save({
            chatId: this.getChatId(),
            payload: pendingSend.payload,
            sentAt: pendingSend.sentAt,
        });
    }
    resolvePendingSend(messageId) {
        this.pendingSends.delete(messageId);
        void message_1.MessageOutbox.getInstance().remove(messageId);
    }
    /**
     * The socket emit is fire-and-forget: a send that leaves while the connection
     * is already silently dead never gets an ack and never gets an echo, so the
     * placeholder would otherwise sit in PENDING forever. The adapter's existing
     * ack timeout is the only signal that this happened.
     */
    onSendTimedOut(data) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!(data === null || data === void 0 ? void 0 : data.timedOut)) {
                return;
            }
            if (data.chatId !== this.getChatId()) {
                return;
            }
            const pendingSend = this.pendingSends.get(data.messageId);
            const message = this.findMessageById(data.messageId);
            if (!pendingSend || !message) {
                return;
            }
            if (message.getMessage().status !== models_1.MESSAGE_STATUS.PENDING) {
                this.resolvePendingSend(data.messageId);
                return;
            }
            // A 200 ack means the backend stored the message and only the CHAT_MESSAGE
            // echo went missing. Showing that as failed would invite a duplicate resend
            // of something already delivered.
            if (data.ackReceived) {
                this.resolvePendingSend(data.messageId);
                this.setMessageStatus(data.messageId, models_1.MESSAGE_STATUS.ACTIVE);
                return;
            }
            // With the socket down the emit never left, so the server cannot have it.
            // Skipping the verify avoids an HTTP call that would fail with ERR_NETWORK
            // and trip the app-wide offline overlay on top of the failed send.
            const landed = this.organizationUser.getNetworkManager().isSocketConnected()
                ? // messageId is indexed but not unique on the backend, so a blind resend
                    // of a send that actually landed would create a real duplicate. Ask the
                    // server first and only fail when it genuinely isn't there.
                    yield this.messageExistsOnServer(data.messageId, pendingSend.sentAt)
                : false;
            if (((_a = this.findMessageById(data.messageId)) === null || _a === void 0 ? void 0 : _a.getMessage().status) !==
                models_1.MESSAGE_STATUS.PENDING) {
                return;
            }
            if (landed) {
                this.resolvePendingSend(data.messageId);
                this.setMessageStatus(data.messageId, models_1.MESSAGE_STATUS.ACTIVE);
                return;
            }
            this.setMessageStatus(data.messageId, models_1.MESSAGE_STATUS.FAILED);
        });
    }
    messageExistsOnServer(messageId, sentAt) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter
                    .getMessageAdapter()
                    .syncMessages(this.getChatId(), {
                    chatType: this.getChatType(),
                    lastSyncedAt: sentAt - utils_1.HHNConstants.SEND_VERIFY_LOOKBACK_MS,
                    limit: utils_1.HHNConstants.SYNC_PAGINATION_LIMIT,
                    total: 0,
                });
                if (response.isAborted) {
                    return false;
                }
                return response.data.data.some(message => message.messageId === messageId);
            }
            catch (_a) {
                // A failed verify is not evidence the message landed. Fall through to
                // FAILED and let the user retry rather than leaving it stuck in PENDING.
                return false;
            }
        });
    }
    /**
     * Retries are uncapped: every one is a deliberate tap that verifies against
     * the server before re-emitting, so the duplicate risk does not grow with the
     * attempt count and a cap would only strand a sendable message.
     *
     * Deliberately independent of socket state too. The message rows are
     * memoised, so a condition that can change without the message changing would
     * leave the control on screen but inert — the tap would land on a button that
     * silently does nothing. Connectivity is handled when the retry actually runs.
     */
    canRetryMessage(message) {
        return this.pendingSends.has(message.getMessage().messageId);
    }
    retryFailedMessage(message) {
        void this.retrySend(message.getMessage().messageId);
    }
    canRetryEdit(message) {
        const messageData = message.getMessage();
        return (messageData.editStatus === models_1.EDIT_MESSAGE_STATUS.FAILED &&
            this.pendingEdits.has(messageData.id));
    }
    retryFailedEdit(message) {
        const serverMessageId = message.getMessage().id;
        const pendingEdit = this.pendingEdits.get(serverMessageId);
        if (!pendingEdit) {
            return;
        }
        this.setMessageEditStatus(serverMessageId, models_1.EDIT_MESSAGE_STATUS.PENDING);
        this.sendMessageHandler.editMessage(pendingEdit.payload, data => {
            this.onEditMessageResponse(data, pendingEdit.payload);
        }, () => {
            this.setMessageEditStatus(serverMessageId, models_1.EDIT_MESSAGE_STATUS.FAILED);
        });
    }
    retrySend(messageId) {
        return __awaiter(this, void 0, void 0, function* () {
            const pendingSend = this.pendingSends.get(messageId);
            const message = this.findMessageById(messageId);
            if (!pendingSend || !message || !this.canRetryMessage(message)) {
                return;
            }
            if (this.retriesInFlight.has(messageId)) {
                return;
            }
            this.retriesInFlight.add(messageId);
            try {
                // Acknowledge the tap straight away, so waiting for the socket reads as
                // sending rather than as a dead control.
                this.setMessageStatus(messageId, models_1.MESSAGE_STATUS.PENDING);
                const connected = yield this.waitForSocket();
                if (!connected) {
                    // No attempt consumed — the message never left, so the user keeps the
                    // same number of tries.
                    this.setMessageStatus(messageId, models_1.MESSAGE_STATUS.FAILED);
                    return;
                }
                yield this.emitRetry(messageId, pendingSend);
            }
            finally {
                this.retriesInFlight.delete(messageId);
            }
        });
    }
    emitRetry(messageId, pendingSend) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            // The first attempt may have reached the server after all — a silently
            // buffered emit that flushed on reconnect looks identical from here. Only
            // re-emit once the server has confirmed it does not have the message,
            // otherwise the non-unique messageId yields a genuine duplicate.
            const landed = yield this.messageExistsOnServer(messageId, pendingSend.sentAt);
            if (landed) {
                this.resolvePendingSend(messageId);
                this.setMessageStatus(messageId, models_1.MESSAGE_STATUS.ACTIVE);
                return;
            }
            // Counted here rather than on the tap: a tap that times out waiting for the
            // socket, or one the server turns out to have already stored, never puts
            // the message back on the wire.
            const retriedSend = Object.assign(Object.assign({}, pendingSend), { sentAt: Date.now(), payload: Object.assign(Object.assign({}, pendingSend.payload), { retries: ((_a = pendingSend.payload.retries) !== null && _a !== void 0 ? _a : 0) + 1 }) });
            this.pendingSends.set(messageId, retriedSend);
            this.persistPendingSend(retriedSend);
            // Re-emitted under the original messageId so a retry that races a
            // late-landing first attempt cannot create a second message.
            this.socketAdapter.sendMessage(retriedSend.payload, this.onSendMessageResponse);
        });
    }
    waitForSocket() {
        const networkManager = this.organizationUser.getNetworkManager();
        if (networkManager.isSocketConnected()) {
            return Promise.resolve(true);
        }
        return new Promise(resolve => {
            let settled = false;
            const settle = (connected) => {
                if (settled) {
                    return;
                }
                settled = true;
                clearTimeout(timer);
                unsubscribe();
                resolve(connected);
            };
            const timer = setTimeout(() => settle(false), utils_1.HHNConstants.RETRY_SOCKET_WAIT_MS);
            const unsubscribe = networkManager.registerSocketAuthSuccessListener(() => __awaiter(this, void 0, void 0, function* () { return settle(true); }));
        });
    }
    sendMedia(mediaDraft, responseCallback) {
        return __awaiter(this, void 0, void 0, function* () {
            const onResponse = responseCallback
                ? (data, socketPayload) => {
                    this.onSendMessageResponse(data, socketPayload);
                    responseCallback(data, socketPayload);
                }
                : this.onSendMessageResponse;
            const messagePayload = this.sendMessageHandler.sendMedia(mediaDraft, onResponse);
            const updatedMessage = (0, mappers_1.createMessageResponseFromPayload)(messagePayload, this.userDirectory, mediaDraft);
            this.trackPendingSend(messagePayload, updatedMessage.createdAt);
            Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.SEND_MESSAGE, this.getChatId()), updatedMessage);
        });
    }
    sendMessage(payload, sendMessageType, responseCallback) {
        const onResponse = responseCallback
            ? (data, socketPayload) => {
                this.onSendMessageResponse(data, socketPayload);
                responseCallback(data, socketPayload);
            }
            : this.onSendMessageResponse;
        let messagePayload;
        switch (sendMessageType) {
            case IChat_1.SEND_MESSAGE_TYPE.PRIORITY:
                messagePayload = this.sendMessageHandler.sendPriority(payload, onResponse);
                break;
            case IChat_1.SEND_MESSAGE_TYPE.REMINDER:
                messagePayload = this.sendMessageHandler.sendReminder(payload, onResponse);
                break;
            case IChat_1.SEND_MESSAGE_TYPE.LOCATION:
                messagePayload = this.sendMessageHandler.sendLocation(payload, onResponse);
                break;
            default:
                messagePayload = this.sendMessageHandler.sendNormal(payload, onResponse);
                break;
        }
        const updatedMessage = (0, mappers_1.createMessageResponseFromPayload)(messagePayload, this.userDirectory);
        this.trackPendingSend(messagePayload, updatedMessage.createdAt);
        Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.SEND_MESSAGE, this.getChatId()), updatedMessage);
    }
    editMessage(payload, responseCallback, onTimeout) {
        const existingMessage = this.findMessageByServerId(payload._id);
        if (!existingMessage) {
            return;
        }
        const originalMessage = existingMessage.getMessage();
        const finalPayload = originalMessage.type === models_1.MESSAGE_TYPE.PRIORITY
            ? Object.assign(Object.assign({}, payload), { mentionedUsers: [], isVisibleToPatient: false, isVisibleToPhysician: false }) : payload;
        if (!this.hasEditChanges(originalMessage, finalPayload)) {
            responseCallback === null || responseCallback === void 0 ? void 0 : responseCallback({
                statusCode: 200,
                message: "No changes",
                data: finalPayload,
            }, finalPayload);
            return;
        }
        this.trackPendingEdit(finalPayload, originalMessage);
        this.applyPendingEdit(finalPayload);
        this.sendMessageHandler.editMessage(finalPayload, data => {
            this.onEditMessageResponse(data, finalPayload);
            responseCallback === null || responseCallback === void 0 ? void 0 : responseCallback(data, finalPayload);
        }, () => {
            this.setMessageEditStatus(finalPayload._id, models_1.EDIT_MESSAGE_STATUS.FAILED);
            onTimeout === null || onTimeout === void 0 ? void 0 : onTimeout();
        });
    }
    hasEditChanges(original, payload) {
        var _a, _b;
        const originalMentions = [...((_a = original.mentionedUsers) !== null && _a !== void 0 ? _a : [])].sort();
        const editedMentions = [...payload.mentionedUsers].sort();
        const mentionsChanged = originalMentions.length !== editedMentions.length ||
            originalMentions.some((userId, index) => userId !== editedMentions[index]);
        const bodyChanged = payload.body !== undefined && payload.body !== original.body;
        const patientVisibilityChanged = payload.isVisibleToPatient !== undefined &&
            payload.isVisibleToPatient !== Boolean(original.isVisibleToPatient);
        const physicianVisibilityChanged = payload.isVisibleToPhysician !== undefined &&
            payload.isVisibleToPhysician !== Boolean(original.isVisibleToPhysician);
        const linksChanged = payload.links !== undefined &&
            JSON.stringify(payload.links) !== JSON.stringify((_b = original.links) !== null && _b !== void 0 ? _b : []);
        return (bodyChanged ||
            mentionsChanged ||
            patientVisibilityChanged ||
            physicianVisibilityChanged ||
            linksChanged);
    }
    applyPendingEdit(payload) {
        const existingMessage = this.findMessageByServerId(payload._id);
        if (!existingMessage) {
            return;
        }
        const currentMessage = existingMessage.getMessage();
        const updatedMessage = this.makeDetachedMessage(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, currentMessage), (payload.body !== undefined && {
            body: payload.body,
        })), { mentionedUsers: payload.mentionedUsers }), (payload.links !== undefined && {
            links: payload.links,
        })), (payload.isVisibleToPatient !== undefined && {
            isVisibleToPatient: payload.isVisibleToPatient,
        })), (payload.isVisibleToPhysician !== undefined && {
            isVisibleToPhysician: payload.isVisibleToPhysician,
        })), { 
            //isEdited: true,
            editStatus: models_1.EDIT_MESSAGE_STATUS.PENDING }));
        this._messages = Object.assign(Object.assign({}, this._messages), { messages: this._messages.messages.map(message => message.getMessage().id === payload._id ? updatedMessage : message) });
        this.notifyChange();
    }
    setMessageEditStatus(serverMessageId, editStatus) {
        const existingMessage = this.findMessageByServerId(serverMessageId);
        if (!existingMessage) {
            return;
        }
        const updatedMessage = this.makeDetachedMessage(Object.assign(Object.assign({}, existingMessage.getMessage()), { editStatus }));
        this._messages = Object.assign(Object.assign({}, this._messages), { messages: this._messages.messages.map(message => message.getMessage().id === serverMessageId ? updatedMessage : message) });
        this.notifyChange();
    }
    makeResendMessageAndSend(messageData, type = IChat_1.SEND_MESSAGE_TYPE.NORMAL) {
        const messagePayload = {
            isResend: true,
            body: messageData.body,
            mentionedUsers: type === IChat_1.SEND_MESSAGE_TYPE.PRIORITY ? [] : messageData.mentionedUsers,
            isVisibleToPatient: messageData.isVisibleToPatient,
            isVisibleToPhysician: messageData.isVisibleToPhysician,
            links: messageData.links,
            reminder: messageData.reminder,
            form: messageData.form
                ? Object.assign(Object.assign({}, messageData.form), { filledAs: messageData.form.filledAs || "", templateType: messageData.form.templateType }) : undefined,
            type: type === IChat_1.SEND_MESSAGE_TYPE.PRIORITY
                ? models_1.MESSAGE_TYPE.PRIORITY
                : models_1.MESSAGE_TYPE.NORMAL,
            contentType: messageData.contentType,
            images: messageData.images,
            voiceMessage: messageData.voiceMessage,
            videos: messageData.videos,
            documents: messageData.documents,
        };
        const finalPayload = this.sendMessageHandler.sendMessage(messagePayload, this.onSendMessageResponse);
        const updatedMessage = (0, mappers_1.createMessageResponseFromPayload)(finalPayload, this.userDirectory);
        this.trackPendingSend(finalPayload, updatedMessage.createdAt);
        // Without a placeholder a resend showed nothing at all until the echo came
        // back, so a lost one was invisible — no bubble, no failure, no trace.
        Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.SEND_MESSAGE, this.getChatId()), updatedMessage);
    }
    resendMessage(message) {
        this.makeResendMessageAndSend(message.getMessage());
    }
    resendAsPriorityMessage(message) {
        this.makeResendMessageAndSend(message.getMessage(), IChat_1.SEND_MESSAGE_TYPE.PRIORITY);
    }
    addMessageHandler(cb) {
        return Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.RECEIVE_MESSAGE, this.getChatId()), (message) => {
            this.pushMessage(cb, message);
        });
    }
    sendMessageListener(cb) {
        return Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.SEND_MESSAGE, this.getChatId()), (message) => {
            this.pushMessage(cb, message);
        });
    }
    sendFormMessage(payload, responseCallback, onTimeout) {
        this.sendMessageHandler.sendFormMessage(payload, responseCallback, onTimeout);
    }
    fetchChatInfo(source, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const chatInfoReponse = yield this.chatsChatInfo.fetchChatInfo(this._chatInfo.id, source, context);
            if (!chatInfoReponse.isAborted) {
                this._chatInfo = chatInfoReponse.data;
            }
        });
    }
    syncMessages(lastHeartbeatReceivedAt, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const currentTime = (0, utils_1.currentEpoch)();
            const messageResponse = yield this.httpAdapter
                .getMessageAdapter()
                .syncMessages(this.getChatId(), {
                chatType: this.getChatType(),
                lastSyncedAt: lastHeartbeatReceivedAt,
                limit: utils_1.HHNConstants.SYNC_PAGINATION_LIMIT,
                total: 0,
            }, context);
            if (!messageResponse.isAborted) {
                if (messageResponse.data.hasNext) {
                    // Adding more context for Sentry
                    const syncErrorInfo = {
                        message: `Sync page size exceeded! offline duration: ${(currentTime - lastHeartbeatReceivedAt) / 60000} minutes`,
                        chatId: this.getChatId(),
                        chatType: this.getChatType(),
                        lastSyncedAt: lastHeartbeatReceivedAt,
                        limit: utils_1.HHNConstants.SYNC_PAGINATION_LIMIT,
                    };
                    throw new SyncException_1.SyncException(syncErrorInfo);
                }
                const newMessagesList = (0, mappers_1.messagesMapper)(messageResponse.data, this.userDirectory, this.organizationUser.getOrganization(), this.makeMessage.bind(this));
                if (newMessagesList.messages.length > 0) {
                    const filteredMessagesList = this.filterPaginatedOutMessages(newMessagesList);
                    ({ mediaList: this.mediaList, messages: this._messages } =
                        this.upsertMessages(this._messages, this.mediaList, filteredMessagesList, (existingMessages, newMessaages) => {
                            const { 
                            /* eslint-disable @typescript-eslint/no-unused-vars */
                            messages, mediaList, limit, hasNext, total, page, messageFilters } = newMessaages, rest = __rest(newMessaages, ["messages", "mediaList", "limit", "hasNext", "total", "page", "messageFilters"]);
                            /* eslint-enable @typescript-eslint/no-unused-vars */
                            return Object.assign(Object.assign({}, this.pageAndFilterData(existingMessages)), rest);
                        }, "CUSTOM", (existingItems, newItem) => {
                            const index = existingItems.findIndex(item => new Date(item.getMessage().createdAt) <
                                new Date(newItem.getMessage().createdAt));
                            if (index === -1) {
                                return [...existingItems, newItem];
                            }
                            return [
                                ...existingItems.slice(0, index),
                                newItem,
                                ...existingItems.slice(index),
                            ];
                        }));
                    this.everFetchedMessages = true;
                }
            }
        });
    }
    /**
     * Filters out synced messages that are older than the oldest loaded message
     * and not already in the loaded list. These are paginated-out messages
     * whose updatedAt changed (e.g. acknowledgment) but shouldn't be
     * re-injected into the current view.
     */
    filterPaginatedOutMessages(syncedMessages) {
        const existingIds = new Set(this._messages.messages.map(m => m.getMessage().id));
        const oldestLoadedCreatedAt = this._messages.messages.length > 0
            ? this._messages.messages[this._messages.messages.length - 1].getMessage().createdAt
            : null;
        const shouldInclude = (m) => {
            if (existingIds.has(m.getMessage().id)) {
                return true;
            }
            if (oldestLoadedCreatedAt &&
                new Date(m.getMessage().createdAt) < new Date(oldestLoadedCreatedAt)) {
                return false;
            }
            return true;
        };
        return Object.assign(Object.assign({}, syncedMessages), { messages: syncedMessages.messages.filter(shouldInclude), mediaList: syncedMessages.mediaList.filter(shouldInclude) });
    }
    pageAndFilterData(messages) {
        return {
            limit: messages.limit,
            hasNext: messages.hasNext,
            total: messages.total,
            page: messages.page,
            messageFilters: messages.messageFilters,
        };
    }
    openChat(context) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.everFetchedMessages) {
                yield this.fetchMessages(context);
            }
        });
    }
    fetchMessages(context) {
        return __awaiter(this, void 0, void 0, function* () {
            const isFirstFetch = !this.everFetchedMessages;
            const rawMessageResponse = yield this.fetchAndUpsertMessages(undefined, context);
            if (!rawMessageResponse.isAborted) {
                this.everFetchedMessages = true;
                if (isFirstFetch) {
                    yield this.restorePendingSends();
                    yield this.restorePendingEdits();
                }
                this.notifyChange();
            }
        });
    }
    /**
     * Recovers sends left unresolved when the previous session ended. Anything
     * the server already has is dropped; the rest resurfaces as FAILED with
     * tap-to-retry rather than being resent silently — a message the user
     * believes was lost should not go out on its own hours later.
     */
    restorePendingSends() {
        return __awaiter(this, void 0, void 0, function* () {
            const outbox = message_1.MessageOutbox.getInstance();
            if (!outbox.isEnabled()) {
                return;
            }
            const records = yield outbox.listForChat(this.getChatId());
            // The message list orders by createdAt, and sends made in the same
            // millisecond would otherwise come back in an arbitrary order. The outbox
            // array is the authority on sequence, so nudge any tie forward to keep it.
            let previousCreatedAt = 0;
            for (const record of records) {
                const { messageId } = record.payload;
                if (this.pendingSends.has(messageId)) {
                    continue;
                }
                if (this.findMessageById(messageId)) {
                    yield outbox.remove(messageId);
                    continue;
                }
                this.pendingSends.set(messageId, {
                    payload: record.payload,
                    sentAt: record.sentAt,
                });
                const createdAt = Math.max(record.sentAt, previousCreatedAt + 1);
                previousCreatedAt = createdAt;
                const restoredMessage = Object.assign(Object.assign({}, (0, mappers_1.createMessageResponseFromPayload)(record.payload, this.userDirectory)), { createdAt, updatedAt: createdAt });
                Observable_1.Observable.getInstance().notify((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.SEND_MESSAGE, this.getChatId()), restoredMessage);
                this.setMessageStatus(messageId, models_1.MESSAGE_STATUS.FAILED);
            }
        });
    }
    restorePendingEdits() {
        return __awaiter(this, void 0, void 0, function* () {
            const outbox = message_1.EditOutbox.getInstance();
            if (!outbox.isEnabled()) {
                return;
            }
            const records = yield outbox.listForChat(this.getChatId());
            for (const record of records) {
                const message = this.findMessageByServerId(record.payload._id);
                if (!message) {
                    yield outbox.remove(record.payload._id);
                    continue;
                }
                this.pendingEdits.set(record.payload._id, {
                    payload: record.payload,
                    originalMessage: message.getMessage(),
                    sentAt: record.sentAt,
                });
                this.applyPendingEdit(record.payload);
                // After a reload, do not claim it is still actively sending.
                // Its delivery result is unknown, so offer Retry.
                this.setMessageEditStatus(record.payload._id, models_1.EDIT_MESSAGE_STATUS.FAILED);
            }
        });
    }
    getMediaById(mediaId) {
        // For private chats: media is stored in _userMedia
        if (this.getChatType() === models_1.CHAT_TYPE.PRIVATE) {
            return this._userMedia.find(item => item.getMessage().id === mediaId);
        }
        // For group and broadcast chats: media can be found in chatInfo mediaList or messages
        const { mediaList } = this.chatInfo;
        const media = mediaList === null || mediaList === void 0 ? void 0 : mediaList.find(item => item.getMessage().id === mediaId);
        return media !== null && media !== void 0 ? media : this.getMessageById(mediaId);
    }
    getAttachmentById(attachmentId) {
        if (this.chatInfo.groupType !== models_1.GROUP_TYPE.PATIENT) {
            return undefined;
        }
        const { attachments } = this.chatInfo;
        return attachments === null || attachments === void 0 ? void 0 : attachments.find(item => item.id === attachmentId);
    }
    enableDisableGroupEmail(requestData) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.httpAdapter
                .getChatAdapter()
                .enableDisableGroupEmail(requestData);
        });
    }
    getGroupAssets(assetType) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.assetType !== assetType) {
                this._groupAssets = this.resetGroupAsset();
            }
            this.assetType = assetType;
            if (this._groupAssets.page !=
                Math.ceil(this._groupAssets.total / utils_1.HHNConstants.PAGINATION_LIMIT) + 1) {
                const response = yield this.httpAdapter
                    .getChatAdapter()
                    .getGroupAssets(this.getChatId(), assetType, {
                    chatType: this.getChatType(),
                    limit: utils_1.HHNConstants.PAGINATION_LIMIT,
                    pageNo: this._groupAssets.page + 1,
                });
                const groupAssetsData = (0, mappers_1.groupAssetsMapper)(response, this.userDirectory, this.organizationUser.getOrganization(), this.makeMessage.bind(this));
                this._groupAssets = {
                    data: [...this._groupAssets.data, ...groupAssetsData.data],
                    limit: groupAssetsData.limit,
                    total: groupAssetsData.total,
                    page: groupAssetsData.page,
                };
            }
        });
    }
    updateChatInfo(chatInfo) {
        this._chatInfo = chatInfo;
        return this;
    }
    getScheduleVisits(params_1) {
        return __awaiter(this, arguments, void 0, function* (params, acrossAllChats = false) {
            this._scheduledVisits = (0, mappers_1.scheduledVisitsMapper)(yield this.httpAdapter.getCommonAdapter().getScheduledVisits(Object.assign(Object.assign({}, (!acrossAllChats && {
                chatId: this.getChatId(),
                chatType: this.getChatType(),
            })), params)));
        });
    }
    fetchRpmReading(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const makeParams = Object.assign(Object.assign({}, params), { groupId: this.getChatId(), total: 0, limit: 100 });
            const response = yield this.httpAdapter
                .getChatAdapter()
                .getRpmReading(makeParams);
            const mappedData = yield (0, mappers_1.rpmReadingMapper)(response, this.userDirectory, this.organizationUser.getOrganization());
            const mappedReadingsMessages = mappedData.data.map(message => this.makeMessage(message));
            const rpmDevices = this._chatInfo.rpmDevices.map(device => {
                if (device.rpmDeviceType === params.rpmDeviceType) {
                    return Object.assign(Object.assign({}, device), { readings: mappedReadingsMessages });
                }
                return device;
            });
            this._chatInfo = Object.assign(Object.assign({}, this._chatInfo), { rpmDevices });
            this.changeListeners.forEach(l => l.cb(this));
        });
    }
    manageDevicePatient(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.organizationUser.hasAccess(roleAccess_1.FEATURES.MANAGE_RPM_DEVICES)) {
                throw new Error(utils_1.ErrorMessages.noAccessFound);
            }
            const newParams = Object.assign(Object.assign({}, params), { assignedPatientGroupId: this.getChatId() });
            const response = yield this.httpAdapter
                .getChatAdapter()
                .managePatientDevice(newParams);
            if (response.responseType) {
                throw new AssignDeviceException_1.AssignDeviceException(response.responseType);
            }
        });
    }
    exportRequest() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.organizationUser.hasAccess(roleAccess_1.FEATURES.EXPORT_RPM_READINGS)) {
                throw new Error(utils_1.ErrorMessages.noAccessFound);
            }
            const params = {
                chatId: this.getChatId(),
                exportType: "RPM",
                offset: -330,
            };
            yield this.httpAdapter.getChatAdapter().exportRequest(params);
        });
    }
    fetchAssignedPatients(context) {
        return __awaiter(this, void 0, void 0, function* () {
            // eslint-disable-next-line no-useless-catch
            try {
                if (!this.organizationUser.hasAccess(roleAccess_1.FEATURES.VIEW_ASSIGNED_PATIENTS))
                    throw new Error(utils_1.ErrorMessages.noAccessFound);
                const assignedPatientsResponse = yield this.httpAdapter
                    .getChatAdapter()
                    .getAssignedPatients(this._chatInfo.id, context);
                if (!assignedPatientsResponse.isAborted) {
                    this._assignedPatients = (0, mappers_1.assignedPatientsMapper)(assignedPatientsResponse.data);
                }
            }
            catch (e) {
                throw e;
            }
        });
    }
    get assignedPatients() {
        return this._assignedPatients;
    }
    fetchUserMedia(context) {
        return __awaiter(this, void 0, void 0, function* () {
            const userMediaResponse = yield this.httpAdapter
                .getChatAdapter()
                .getUserMedia(this._chatInfo.id, context);
            if (!userMediaResponse.isAborted) {
                this._userMedia = (0, mappers_1.groupInfoMediaListMapper)(userMediaResponse.data, this.userDirectory, this.organizationUser, this.httpAdapter, this.socketAdapter);
            }
        });
    }
    get userMedia() {
        return this._userMedia;
    }
}
exports.default = Chat;
